;$(function () {
  'use strict'

  // Wedding info tooltip on user profile page
  const weddingInfoHandleSelector = '[data-wedding-info-handle]'
  const weddingInfoTooltipSelector = '[data-wedding-info-tooltip]'

  if ($(weddingInfoHandleSelector).length) {
    $(document).on('click', weddingInfoHandleSelector, function (event) {
      event.stopPropagation()

      $(weddingInfoTooltipSelector).toggleClass('profile-cover__tooltip_active')
    })

    $(document).on('click', function () {
      $(weddingInfoTooltipSelector).removeClass('profile-cover__tooltip_active')
    })
  }

  // Blog name (title) on user profile page
  const profileTitleSelector = '[data-profile-title]'

  if ($(profileTitleSelector).length && $(profileTitleSelector).height() > 77) {
    $(profileTitleSelector).addClass('profile-cover__title_fit')
  }
})
